import { Image } from "@common/index";
import { PRODUCT_PLACEHOLDER_SRC } from "@utils/productImage";

interface ProductImageProps {
    src: string;
    alt: string;
    className?: string;
    wrapperClassName?: string;
    /**
     * When true, the browser prioritises this image (no lazy-load,
     * `fetchpriority="high"`). Use for above-the-fold cards.
     */
    priority?: boolean;
}

export const ProductImage = ({
    src,
    alt,
    className,
    wrapperClassName,
    priority,
}: ProductImageProps) => (
    <Image
        src={src}
        alt={alt}
        className={className}
        wrapperClassName={wrapperClassName}
        fallbackSrc={PRODUCT_PLACEHOLDER_SRC}
        priority={priority}
        data-testid="product-image"
    />
);
